import {createSlice} from "@reduxjs/toolkit";

const internetStatusSlice = createSlice({
    name: "internetStatus",
    initialState: true,
    reducers:{
        setInternetStatus: (state, action) => action.payload,
        setInternetOn : (state, action) => true,
        setInternetOff: (state, action) => false
    }
});

export const { setInternetStatus, setInternetOn, setInternetOff } = internetStatusSlice.actions;

export default internetStatusSlice.reducer;
